import React, { Component } from "react";
class Auth extends Component {
	render() {
		return <div style={{ overflowX: "hidden" }}>{this.props.children}</div>;
	}
}
export default Auth;
